import styled from "styled-components";
import { motion } from "framer-motion"

import { CircleInterface , ButtonInterface } from "./interfaces";

import colors from "../../assets/css/colors";

import { PeriodButtonInterface, SearchAndFilter } from "./interfaces"

export const Main = styled(motion.div)`
  box-shadow: 0px 3px 6px ${colors.tableShadow};
  border-radius: 10px;
  width: 100%;

  .row{
    display: flex;
    align-items: baseline;
  }

  @media (max-width: 785.98px) {
    .row{
      flex-wrap: ${(props: SearchAndFilter) => (props.searchAndFilter ? "inherit" : "wrap") };

      .d-flex{
        width: 66%;
      }
    }
  }
`;


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;

  @media (max-width: 599px) {
      margin-bottom: 0;
    }

  .inputWithIcon{
    display: flex;
    align-items: center;

    input{
      padding-left: 10px;
    }
  }
  
  #tableform{
    height: 35px;
  }

  #tableformimg{
    top: 3.6px;
  }

`
export const BoxForSearch = styled.div` 
  display: flex;
  flex-direction: row-reverse;
  margin: 10px 0px;
  border: 1px solid black;
  
  input{
    width: 100%;
    border: none;
    color: ${colors.tertiary};
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    margin-left: 10px;
    &:focus{
      outline: 0;
    }
  }
` 

export const ButtonGroupCol = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @media (max-width: 600px) {
        margin-top: 10px;
        margin-left: 13px;
        justify-content: flex-start;
    }
`

export const PageButtonGroup = styled.div`
  width: 100%;
    display: flex;
    justify-content: flex-end;

    @media (max-width: 500px) {
        justify-content: center;
    }
`

export const CircleOption = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-radius: 13px;
  background-color: ${colors.circleOptionBorder};
  border-width: 0px;
`;

export const CirclePage = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-radius: 13px;
  background-color: ${(p: CircleInterface) =>
    p.active ? colors.primary : colors.white};
  border-width: 1px;
  border-color: ${(p: CircleInterface) => (p.active ? colors.primary : colors.grayDark)};
  color: ${(p: CircleInterface) => (p.active ? colors.white : colors.grayDark)};
  margin: 8px;
  font-size: 8px;

  &:hover {
    cursor: pointer;
  }
`;

export const CirclePageRight = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: solid;
  border-radius: 13px;
  background-color: ${(p: CircleInterface) =>
    p.active ? colors.primary : colors.white};
  border-width: 1px;
  border-color: ${(p: CircleInterface) => (p.active ? colors.primary : colors.grayDark)};
  color: ${(p: CircleInterface) => (p.active ? colors.white : colors.grayDark)};
  margin: 8px;
  margin-right: 28px;
  font-size: 8px;

    @media (max-width: 500px){
      margin-right: 8px
    }

  &:hover {
    cursor: pointer;
  }
`;

export const Button = styled.button`
  font-size: 10px;
  height: 2.2rem;
  margin-right: 1.3rem;
  color:${(p: ButtonInterface) => (p.outline ?  colors.primary :colors.white)};
  border-color:  ${(p: ButtonInterface) => (p.outline ? colors.secondary : colors.primary)};  

  border-width:1px;
  border-style:solid;
  outline: none;
  border-radius: 4px;
  background:  ${(p: ButtonInterface) => (p.outline ? colors.white : colors.primary)};

  transition: all.5s ease;

  -webkit-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
  -moz-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
  box-shadow: -4px 14px 50px -15px rgba(238, 168, 73, 1);

  &:hover {
    color:${colors.white};
    background: ${colors.quaternary};
  }

  &:focus {
    color:${colors.white};
    background: ${colors.quaternary};
    outline: none !important;
  }

  &:disabled {
    background: ${colors.grayDark};
    color: ${colors.white};
    border-color: ${colors.grayLight};
    cursor: wait;
  }
`;

export const FilterTitle = styled.span`
  display: flex;
  align-items: center;
  font: normal normal normal 16px Circular Std Book;
  color: ${colors.tertiary};

  @media(max-width: 500px){
    font-size: 12px;
  }
`;

export const FilterInputCalenderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  padding: 0px 20px;
  background: ${colors.white} 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 5px ${colors.filterShadow};
  border-radius: 7px;
  height: 27px;

  @media(max-width: 500px){
    margin-left: 5px;
    padding: 0px 0px 0px 2px;
    width: 85%;
  }
`

export const InputCalendar = styled.input`
  text-align: center;
  vertical-align: middle;
  border: 0;
  font: normal normal normal 12px Circular Std Book;
  color: ${colors.tertiary};
  padding: 0;
  outline: 0;
  line-height: 1;

  &:focus{
    outline: 0;
  }

  @media (max-width: 500px){
    width: 40%;
  }
`;

export const PeriodButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    cursor: pointer;
    width: 63px;
    height: 21px;
    padding: 4px 0px;
    border: 1px solid ${colors.primary};
    border-radius: 5px;
    margin-left: 15px;
    background-color: ${(p: PeriodButtonInterface) => p.isActive ? colors.primary : colors.white};
    color: ${(p: PeriodButtonInterface) => p.isActive ? colors.white : colors.primary};

    &:focus{
        outline: 0;
    }

    @media(max-width: 768px){
      margin-left: 0px;
      margin-right: 15px;
  }
`;

export const PeriodButtonText = styled.p`
    line-height: 1;
    font: normal normal 600 10px Muli;
    margin: 0;
`;

export const FilterDateAndButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &::nth-last-child(1){
    justify-content: flex-start;
  }

  @media (max-width: 500px){
    width: 250px;
  }

  @media(max-width: 785px){
    display: block;
  }
`

export const FilterDateConteiner = styled.div`
  display: flex;
  align-items: center;
  
  @media(max-width: 768px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }
`;

export const PeriodButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  
  @media(max-width: 768px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 5px;
  }
`;